"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ordinal;
exports.implicit = void 0;
var _d3Collection = require("d3-collection");
var _array = require("./array");
var implicit = {
  name: "implicit"
};
exports.implicit = implicit;
function ordinal(range) {
  var index = (0, _d3Collection.map)(),
    domain = [],
    unknown = implicit;
  range = range == null ? [] : _array.slice.call(range);
  function scale(d) {
    var key = d + "",
      i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }
  scale.domain = function (_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = (0, _d3Collection.map)();
    var i = -1,
      n = _.length,
      d,
      key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };
  scale.range = function (_) {
    return arguments.length ? (range = _array.slice.call(_), scale) : range.slice();
  };
  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  scale.copy = function () {
    return ordinal().domain(domain).range(range).unknown(unknown);
  };
  return scale;
}